import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import { loadConfig } from "./config";
import axios from "axios";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Load config.xml before rendering the application
root.render(
    <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
            <div className="spinner-border" role="status" />
            <div className="mt-3">Loading...</div>
        </div>
    </div>
);

loadConfig()
    .catch(() => undefined)
    .finally(() => {
        if (typeof window !== "undefined" && window.location && window.location.hostname) {
            axios.defaults.headers.common["X-Tenant-Host"] = window.location.hostname;
        }
        const token = localStorage.getItem("token");
        if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        root.render(<App />);
    });
